"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 18 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsx)("path", {
      fill: "currentColor",
      d: "M4.263 6.514a.766.766 0 00-.27-.165.85.85 0 00-.622 0 .722.722 0 00-.442.424c-.146.329-.042.71.253.93s.705.218 1 0 .398-.601.253-.93a.782.782 0 00-.172-.26zm5.964-1.8h.818c.452 0 .819-.351.819-.785 0-.434-.367-.786-.819-.786h-.818c-.452 0-.818.352-.818.786 0 .434.366.785.818.785zm-3.272 0h.818c.452 0 .818-.351.818-.785 0-.434-.366-.786-.818-.786h-.818c-.452 0-.819.352-.819.786 0 .434.367.785.819.785zM4.5 3.143h-.818c-.452 0-.818.352-.818.786 0 .434.366.785.818.785H4.5c.452 0 .818-.351.818-.785 0-.434-.366-.786-.818-.786zM15.545 0H2.455C1.099 0 0 1.055 0 2.357v6.286C0 9.945 1.099 11 2.455 11h13.09C16.901 11 18 9.945 18 8.643V2.357C18 1.055 16.901 0 15.545 0zm.819 8.643c0 .434-.367.786-.819.786H2.455c-.452 0-.819-.352-.819-.786V2.357c0-.434.367-.786.819-.786h13.09c.452 0 .819.352.819.786zm-4.91-2.357H6.546c-.451 0-.818.351-.818.785s.367.786.818.786h4.91c.451 0 .818-.352.818-.786s-.367-.785-.818-.785zm2.864-3.143H13.5c-.452 0-.818.352-.818.786 0 .434.366.785.818.785h.818c.452 0 .818-.351.818-.785 0-.434-.366-.786-.818-.786zm.581 3.37a.823.823 0 00-.27-.164.85.85 0 00-.622 0 .766.766 0 00-.27.165.782.782 0 00-.172.259c-.13.294-.062.635.173.862s.59.294.897.17a.785.785 0 00.501-.734.638.638 0 00-.065-.298.782.782 0 00-.172-.26z"
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Shortcuts.js.map